module.exports = __webpack_public_path__ + "static/media/reintegros.087b83a1.png";